// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file kitecorp/transferify/admin/v1/sponsor_admin.proto (package kitecorp.transferify.admin.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_kitecorp_options_v1_options } from "../../../options/v1/options_pb";
import type { BackdropCategory, BackdropOptions, BackdropTemplate } from "../../storefront/v1/backdrop_pb";
import { file_kitecorp_transferify_storefront_v1_backdrop } from "../../storefront/v1/backdrop_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file kitecorp/transferify/admin/v1/sponsor_admin.proto.
 */
export const file_kitecorp_transferify_admin_v1_sponsor_admin: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_kitecorp_options_v1_options, file_kitecorp_transferify_storefront_v1_backdrop]);

/**
 * Asks for the review queue.
 *
 * @generated from message kitecorp.transferify.admin.v1.ListPendingBookingsRequest
 */
export type ListPendingBookingsRequest = Message<"kitecorp.transferify.admin.v1.ListPendingBookingsRequest"> & {
};

/**
 * Describes the message kitecorp.transferify.admin.v1.ListPendingBookingsRequest.
 * Use `create(ListPendingBookingsRequestSchema)` to create a new message.
 */
export const ListPendingBookingsRequestSchema: GenMessage<ListPendingBookingsRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_admin_v1_sponsor_admin, 0);

/**
 * The review queue.
 *
 * @generated from message kitecorp.transferify.admin.v1.ListPendingBookingsResponse
 */
export type ListPendingBookingsResponse = Message<"kitecorp.transferify.admin.v1.ListPendingBookingsResponse"> & {
  /**
   * The bookings, in the order the call describes.
   *
   * @generated from field: repeated kitecorp.transferify.admin.v1.OperatorBooking bookings = 1;
   */
  bookings: OperatorBooking[];
};

/**
 * Describes the message kitecorp.transferify.admin.v1.ListPendingBookingsResponse.
 * Use `create(ListPendingBookingsResponseSchema)` to create a new message.
 */
export const ListPendingBookingsResponseSchema: GenMessage<ListPendingBookingsResponse> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_admin_v1_sponsor_admin, 1);

/**
 * Asks for the bookings that overlap a window.
 *
 * @generated from message kitecorp.transferify.admin.v1.GetSponsorScheduleRequest
 */
export type GetSponsorScheduleRequest = Message<"kitecorp.transferify.admin.v1.GetSponsorScheduleRequest"> & {
  /**
   * The first day of the window, YYYY-MM-DD. Required.
   *
   * @generated from field: string from = 1;
   */
  from: string;

  /**
   * The last day of the window, YYYY-MM-DD, included. Required.
   *
   * @generated from field: string to = 2;
   */
  to: string;
};

/**
 * Describes the message kitecorp.transferify.admin.v1.GetSponsorScheduleRequest.
 * Use `create(GetSponsorScheduleRequestSchema)` to create a new message.
 */
export const GetSponsorScheduleRequestSchema: GenMessage<GetSponsorScheduleRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_admin_v1_sponsor_admin, 2);

/**
 * The bookings that overlap the window.
 *
 * @generated from message kitecorp.transferify.admin.v1.GetSponsorScheduleResponse
 */
export type GetSponsorScheduleResponse = Message<"kitecorp.transferify.admin.v1.GetSponsorScheduleResponse"> & {
  /**
   * The bookings, earliest start first.
   *
   * @generated from field: repeated kitecorp.transferify.admin.v1.OperatorBooking bookings = 1;
   */
  bookings: OperatorBooking[];
};

/**
 * Describes the message kitecorp.transferify.admin.v1.GetSponsorScheduleResponse.
 * Use `create(GetSponsorScheduleResponseSchema)` to create a new message.
 */
export const GetSponsorScheduleResponseSchema: GenMessage<GetSponsorScheduleResponse> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_admin_v1_sponsor_admin, 3);

/**
 * Asks to approve one booking.
 *
 * @generated from message kitecorp.transferify.admin.v1.ApproveBookingRequest
 */
export type ApproveBookingRequest = Message<"kitecorp.transferify.admin.v1.ApproveBookingRequest"> & {
  /**
   * The booking to approve, an OperatorBooking.booking_id.
   *
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;
};

/**
 * Describes the message kitecorp.transferify.admin.v1.ApproveBookingRequest.
 * Use `create(ApproveBookingRequestSchema)` to create a new message.
 */
export const ApproveBookingRequestSchema: GenMessage<ApproveBookingRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_admin_v1_sponsor_admin, 4);

/**
 * The approved booking.
 *
 * @generated from message kitecorp.transferify.admin.v1.ApproveBookingResponse
 */
export type ApproveBookingResponse = Message<"kitecorp.transferify.admin.v1.ApproveBookingResponse"> & {
  /**
   * The booking as it stands after the approval.
   *
   * @generated from field: kitecorp.transferify.admin.v1.OperatorBooking booking = 1;
   */
  booking?: OperatorBooking | undefined;
};

/**
 * Describes the message kitecorp.transferify.admin.v1.ApproveBookingResponse.
 * Use `create(ApproveBookingResponseSchema)` to create a new message.
 */
export const ApproveBookingResponseSchema: GenMessage<ApproveBookingResponse> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_admin_v1_sponsor_admin, 5);

/**
 * Asks to reject one booking.
 *
 * @generated from message kitecorp.transferify.admin.v1.RejectBookingRequest
 */
export type RejectBookingRequest = Message<"kitecorp.transferify.admin.v1.RejectBookingRequest"> & {
  /**
   * The booking to reject, an OperatorBooking.booking_id.
   *
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * Why the takeover is refused, shown to the advertiser as written: not blank, at most 500 characters, stripped of
   * the whitespace around it.
   *
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * Describes the message kitecorp.transferify.admin.v1.RejectBookingRequest.
 * Use `create(RejectBookingRequestSchema)` to create a new message.
 */
export const RejectBookingRequestSchema: GenMessage<RejectBookingRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_admin_v1_sponsor_admin, 6);

/**
 * The rejected booking.
 *
 * @generated from message kitecorp.transferify.admin.v1.RejectBookingResponse
 */
export type RejectBookingResponse = Message<"kitecorp.transferify.admin.v1.RejectBookingResponse"> & {
  /**
   * The booking as it stands after the rejection.
   *
   * @generated from field: kitecorp.transferify.admin.v1.OperatorBooking booking = 1;
   */
  booking?: OperatorBooking | undefined;
};

/**
 * Describes the message kitecorp.transferify.admin.v1.RejectBookingResponse.
 * Use `create(RejectBookingResponseSchema)` to create a new message.
 */
export const RejectBookingResponseSchema: GenMessage<RejectBookingResponse> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_admin_v1_sponsor_admin, 7);

/**
 * One sponsor takeover booking as the operator sees it, with the advertiser's address and the price.
 *
 * @generated from message kitecorp.transferify.admin.v1.OperatorBooking
 */
export type OperatorBooking = Message<"kitecorp.transferify.admin.v1.OperatorBooking"> & {
  /**
   * The booking's id, the one ApproveBooking and RejectBooking take.
   *
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * The brand whose calendar the booking takes.
   *
   * @generated from field: string brand_key = 2;
   */
  brandKey: string;

  /**
   * Where the booking stands.
   *
   * @generated from field: kitecorp.transferify.admin.v1.OperatorBooking.State state = 3;
   */
  state: OperatorBooking_State;

  /**
   * The backdrop treatment the advertiser chose.
   *
   * @generated from field: kitecorp.transferify.storefront.v1.BackdropTemplate template = 4;
   */
  template: BackdropTemplate;

  /**
   * The category of that treatment.
   *
   * @generated from field: kitecorp.transferify.storefront.v1.BackdropCategory category = 5;
   */
  category: BackdropCategory;

  /**
   * The treatment's options. Absent when the booking has none.
   *
   * @generated from field: kitecorp.transferify.storefront.v1.BackdropOptions options = 6;
   */
  options?: BackdropOptions | undefined;

  /**
   * The sponsor's name.
   *
   * @generated from field: string sponsor_name = 7;
   */
  sponsorName: string;

  /**
   * The address the advertiser gave.
   *
   * @generated from field: string sponsor_email = 8;
   */
  sponsorEmail: string;

  /**
   * The takeover's headline.
   *
   * @generated from field: string headline = 9;
   */
  headline: string;

  /**
   * The takeover's tagline. Absent when it has none.
   *
   * @generated from field: optional string tagline = 10;
   */
  tagline?: string | undefined;

  /**
   * The label of the call-to-action button.
   *
   * @generated from field: string cta_label = 11;
   */
  ctaLabel: string;

  /**
   * The address the call-to-action button opens.
   *
   * @generated from field: string cta_url = 12;
   */
  ctaUrl: string;

  /**
   * The first day of the booking, YYYY-MM-DD.
   *
   * @generated from field: string starts_on = 13;
   */
  startsOn: string;

  /**
   * The last day of the booking, YYYY-MM-DD, included.
   *
   * @generated from field: string ends_on = 14;
   */
  endsOn: string;

  /**
   * The price in the currency's minor unit.
   *
   * @generated from field: int64 amount_minor = 15;
   */
  amountMinor: bigint;

  /**
   * The price's currency, the brand's own, as a lower-case ISO 4217 code.
   *
   * @generated from field: string currency = 16;
   */
  currency: string;

  /**
   * How many times the booking has been served, counted per serve.
   *
   * @generated from field: int64 impressions = 17;
   */
  impressions: bigint;

  /**
   * Why an operator rejected the booking. Absent when none is recorded.
   *
   * @generated from field: optional string rejection_reason = 18;
   */
  rejectionReason?: string | undefined;

  /**
   * When the payment window closes. Absent before the booking is approved.
   *
   * @generated from field: optional google.protobuf.Timestamp payment_due_at = 19;
   */
  paymentDueAt?: Timestamp | undefined;

  /**
   * When a refund is owed, for money taken on a booking that can never run. Absent on every other booking.
   *
   * @generated from field: optional google.protobuf.Timestamp refund_due_at = 20;
   */
  refundDueAt?: Timestamp | undefined;

  /**
   * The addresses of the booking's images, in the order the advertiser sent them.
   *
   * @generated from field: repeated string image_urls = 21;
   */
  imageUrls: string[];

  /**
   * The address of the booking's logo. Absent when it has none.
   *
   * @generated from field: optional string logo_url = 22;
   */
  logoUrl?: string | undefined;

  /**
   * The address of the booking's video. Absent when it has none.
   *
   * @generated from field: optional string video_url = 23;
   */
  videoUrl?: string | undefined;

  /**
   * The address of the video's poster image. Absent when it has none.
   *
   * @generated from field: optional string poster_url = 24;
   */
  posterUrl?: string | undefined;
};

/**
 * Describes the message kitecorp.transferify.admin.v1.OperatorBooking.
 * Use `create(OperatorBookingSchema)` to create a new message.
 */
export const OperatorBookingSchema: GenMessage<OperatorBooking> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_admin_v1_sponsor_admin, 8);

/**
 * Where a booking stands.
 *
 * @generated from enum kitecorp.transferify.admin.v1.OperatorBooking.State
 */
export enum OperatorBooking_State {
  /**
   * Never sent. Present because every proto3 enum needs a zero value.
   *
   * @generated from enum value: STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Submitted and undecided. It holds no calendar slot.
   *
   * @generated from enum value: STATE_PENDING_REVIEW = 1;
   */
  PENDING_REVIEW = 1,

  /**
   * Approved and unpaid, inside its payment window. It holds its dates exclusively and does not serve.
   *
   * @generated from enum value: STATE_AWAITING_PAYMENT = 2;
   */
  AWAITING_PAYMENT = 2,

  /**
   * Approved and paid for, and not yet inside its dates. It holds its dates exclusively.
   *
   * @generated from enum value: STATE_APPROVED = 3;
   */
  APPROVED = 3,

  /**
   * Approved, paid for and inside its dates.
   *
   * @generated from enum value: STATE_ACTIVE = 4;
   */
  ACTIVE = 4,

  /**
   * Its dates have passed.
   *
   * @generated from enum value: STATE_ENDED = 5;
   */
  ENDED = 5,

  /**
   * An operator refused it, with a reason. It never serves and never holds a slot.
   *
   * @generated from enum value: STATE_REJECTED = 6;
   */
  REJECTED = 6,

  /**
   * Approved, and unpaid when its payment window closed. Its dates are free again and it never serves.
   *
   * @generated from enum value: STATE_EXPIRED = 7;
   */
  EXPIRED = 7,

  /**
   * A consumer's withdrawal was received. It no longer serves or holds a slot, and refund_due_at is set.
   *
   * @generated from enum value: STATE_WITHDRAWN = 8;
   */
  WITHDRAWN = 8,
}

/**
 * Describes the enum kitecorp.transferify.admin.v1.OperatorBooking.State.
 */
export const OperatorBooking_StateSchema: GenEnum<OperatorBooking_State> = /*@__PURE__*/
  enumDesc(file_kitecorp_transferify_admin_v1_sponsor_admin, 8, 0);

/**
 * The operator console's sponsor takeover review (kitecorp/contracts#88): the queue of submissions that wait for a
 * decision, the schedule across every brand, and the approval or rejection of one booking. An advertiser's own
 * bookings are not here.
 *
 * @generated from service kitecorp.transferify.admin.v1.SponsorAdminService
 */
export const SponsorAdminService: GenService<{
  /**
   * Lists the bookings that wait for an operator: the submissions in review, oldest submission first, followed by the
   * bookings in any other state that owe a refund, soonest refund due first. A booking in review that owes a refund is
   * listed once. Each booking carries its whole creative and copy. Only a caller who holds the operate action may call
   * it: a signed-in caller without it is PERMISSION_DENIED, a caller who is not signed in is UNAUTHENTICATED, and one
   * whose sign-in cannot be checked right now is UNAVAILABLE. It changes nothing.
   *
   * @generated from rpc kitecorp.transferify.admin.v1.SponsorAdminService.ListPendingBookings
   */
  listPendingBookings: {
    methodKind: "unary";
    input: typeof ListPendingBookingsRequestSchema;
    output: typeof ListPendingBookingsResponseSchema;
  },
  /**
   * Lists the bookings that hold or ask for a calendar slot inside a window, across every brand, earliest start first:
   * those in review, awaiting payment, approved or active, whose dates overlap the window, both ends included. Only a
   * caller who holds the operate action may call it: a signed-in caller without it is PERMISSION_DENIED, a caller who
   * is not signed in is UNAUTHENTICATED, and one whose sign-in cannot be checked right now is UNAVAILABLE. A from or a
   * to that is blank or not a day is INVALID_ARGUMENT. It changes nothing.
   *
   * @generated from rpc kitecorp.transferify.admin.v1.SponsorAdminService.GetSponsorSchedule
   */
  getSponsorSchedule: {
    methodKind: "unary";
    input: typeof GetSponsorScheduleRequestSchema;
    output: typeof GetSponsorScheduleResponseSchema;
  },
  /**
   * Approves one booking that is in review: it takes the brand's dates exclusively and enters its payment window, in
   * the state awaiting payment with a payment_due_at. It does not serve until it is paid for. The advertiser is mailed
   * once the approval is saved; a mail that cannot be sent does not undo it. Only a caller who holds the operate
   * action may call it: a signed-in caller without it is PERMISSION_DENIED, a caller who is not signed in is
   * UNAUTHENTICATED, and one whose sign-in cannot be checked right now is UNAVAILABLE. A booking_id that is not a UUID
   * is INVALID_ARGUMENT. An unknown booking is NOT_FOUND. A booking that is not in review, or whose dates another
   * booking holds by now, is ALREADY_EXISTS. Its idempotency is left unknown, not marked free of side effects: it
   * mails the advertiser, and a repeat is refused.
   *
   * @generated from rpc kitecorp.transferify.admin.v1.SponsorAdminService.ApproveBooking
   */
  approveBooking: {
    methodKind: "unary";
    input: typeof ApproveBookingRequestSchema;
    output: typeof ApproveBookingResponseSchema;
  },
  /**
   * Rejects one booking that is in review, with a reason that the advertiser is shown as written and is mailed once the
   * rejection is saved; a mail that cannot be sent does not undo it. A booking that was approved is not rejected here.
   * Only a caller who holds the operate action may call it: a signed-in caller without it is PERMISSION_DENIED, a
   * caller who is not signed in is UNAUTHENTICATED, and one whose sign-in cannot be checked right now is UNAVAILABLE.
   * A booking_id that is not a UUID, and a reason that is blank or longer than 500 characters, are INVALID_ARGUMENT.
   * An unknown booking is NOT_FOUND. A booking that is not in review is ALREADY_EXISTS. Its idempotency is left
   * unknown, not marked free of side effects: it mails the advertiser, and a repeat is refused.
   *
   * @generated from rpc kitecorp.transferify.admin.v1.SponsorAdminService.RejectBooking
   */
  rejectBooking: {
    methodKind: "unary";
    input: typeof RejectBookingRequestSchema;
    output: typeof RejectBookingResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_kitecorp_transferify_admin_v1_sponsor_admin, 0);

